import {ref, Ref} from "vue"

const token: Ref<string | null> = ref(null)

export default token